// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
* {
    box-sizing: border-box;
  }
  
  .bulk-email-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
    color: #ffffff;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
  }
  
  /* Header */
  .page-header {
    background: linear-gradient(135deg, rgba(43, 184, 221, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%);
    border-bottom: 1px solid rgba(43, 184, 221, 0.2);
    padding: 2rem 1rem;
    text-align: center;
  }
  
  .header-content {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .page-title {
    font-size: clamp(2rem, 5vw, 3.5rem);
    font-weight: 800;
    background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0 0 0.5rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }
  
  .title-icon {
    font-size: 0.8em;
    filter: drop-shadow(0 0 10px rgba(43, 184, 221, 0.5));
  }
  
  .page-subtitle {
    font-size: clamp(1rem, 3vw, 1.25rem);
    color: #94a3b8;
    margin: 0;
    font-weight: 400;
  }
  
  /* Main Content */
  .page-main {
    padding: 2rem 1rem;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .email-container {
    width: 100%;
  }
  
  /* Messages */
  .message {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.5rem;
    border-radius: 12px;
    margin-bottom: 2rem;
    font-weight: 500;
    position: relative;
    animation: slideIn 0.3s ease-out;
  }
  
  .error-message {
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    border: 1px solid #ef4444;
    box-shadow: 0 4px 15px rgba(220, 38, 38, 0.2);
  }
  
  .success-message {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border: 1px solid #22c55e;
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.2);
  }
  
  .message-icon {
    font-size: 1.25rem;
    flex-shrink: 0;
  }
  
  .message-text {
    flex: 1 1;
  }
  
  .message-close {
    background: none;
    border: none;
    color: currentColor;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s ease;
  }
  
  .message-close:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  /* Email Form Card */
  .email-form-card {
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    border: 1px solid #475569;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
  }
  
  .card-header {
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #475569;
  }
  
  .card-title {
    font-size: clamp(1.5rem, 4vw, 2rem);
    font-weight: 700;
    color: #2bb8dd !important;
    margin: 0 0 0.5rem 0;
  }
  
  .card-subtitle {
    color: #94a3b8;
    margin: 0;
    font-size: clamp(0.9rem, 2.5vw, 1rem);
  }
  
  /* Form Styles */
  .email-form {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .form-label {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-weight: 600;
    font-size: 1.1rem;
    color: #e2e8f0;
  }
  
  .label-text {
    color: #e2e8f0;
  }
  
  .label-required {
    color: #ef4444;
    font-weight: 700;
  }
  
  .input-wrapper {
    position: relative;
  }
  
  .form-input,
  .form-textarea {
    width: 100%;
    padding: 1rem 1.25rem;
    background: rgba(0, 0, 0, 0.4) !important;
    border: 2px solid #475569;
    border-radius: 12px;
    color: #ffffff;
    font-size: 1rem;
    font-family: inherit;
    transition: all 0.3s ease;
    resize: none;
  }
  
  .form-input:focus,
  .form-textarea:focus {
    outline: none;
    border-color: #2bb8dd;
    box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.1);
    background: rgba(0, 0, 0, 0.6);
  }
  
  .form-input:disabled,
  .form-textarea:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .form-textarea {
    min-height: 200px;
    line-height: 1.6;
    font-family: inherit;
  }
  
  .input-counter {
    position: absolute;
    bottom: 0.75rem;
    right: 1rem;
    font-size: 0.75rem;
    color: #64748b;
    background: rgba(0, 0, 0, 0.7);
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    pointer-events: none;
  }
  
  /* Templates Section */
  .templates-section {
    padding: 1.5rem;
    background: rgba(43, 184, 221, 0.05);
    border: 1px solid rgba(43, 184, 221, 0.2);
    border-radius: 15px;
    margin: 1rem 0;
  }
  
  .templates-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #2bb8dd;
    margin: 0 0 1rem 0;
    text-align: center;
  }
  
  .templates-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
  }
  
  .template-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background: rgba(43, 184, 221, 0.1);
    border: 1px solid rgba(43, 184, 221, 0.3);
    border-radius: 12px;
    color: #2bb8dd;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    font-weight: 500;
  }
  
  .template-btn:hover:not(:disabled) {
    background: rgba(43, 184, 221, 0.2);
    border-color: #2bb8dd;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(43, 184, 221, 0.2);
  }
  
  .template-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
  
  .template-icon {
    font-size: 1.5rem;
  }
  
  /* Form Actions */
  .form-actions {
    margin-top: 1rem;
    padding-top: 1.5rem;
    border-top: 1px solid #475569;
  }
  
  .send-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 1.25rem 2rem;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border: none;
    border-radius: 15px;
    color: #ffffff;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .send-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(16, 185, 129, 0.3);
  }
  
  .send-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
  
  .button-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  .button-icon {
    font-size: 1.2rem;
  }
  
  .button-text {
    font-weight: 700;
  }
  
  /* Footer */
  .page-footer {
    background: rgba(0, 0, 0, 0.2);
    border-top: 1px solid #475569;
    padding: 1.5rem 1rem;
    margin-top: 2rem;
  }
  
  .footer-content {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }
  
  .footer-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #94a3b8;
    margin: 0;
    font-size: 0.9rem;
  }
  
  .footer-icon {
    font-size: 1rem;
    color: #f59e0b;
  }
  
  /* Animations */
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Mobile Responsive Design */
  @media (max-width: 768px) {
    .page-header {
      padding: 1.5rem 1rem;
    }
    
    .page-title {
      flex-direction: column;
      gap: 0.5rem;
    }
    
    .title-icon {
      font-size: 1em;
    }
    
    .page-main {
      padding: 1.5rem 1rem;
    }
    
    .email-form-card {
      padding: 1.5rem;
      border-radius: 15px;
    }
    
    .card-header {
      margin-bottom: 1.5rem;
      padding-bottom: 1rem;
    }
    
    .email-form {
      gap: 1.5rem;
    }
    
    .form-input,
    .form-textarea {
      padding: 0.875rem 1rem;
      font-size: 16px; /* Prevents zoom on iOS */
    }
    
    .form-textarea {
      min-height: 150px;
    }
    
    .templates-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }
    
    .template-btn {
      padding: 0.875rem;
      font-size: 0.85rem;
    }
    
    .template-icon {
      font-size: 1.25rem;
    }
    
    .send-button {
      padding: 1rem 1.5rem;
      font-size: 1rem;
    }
    
    .message {
      padding: 0.875rem 1rem;
      gap: 0.75rem;
    }
    
    .message-icon {
      font-size: 1.1rem;
    }
    
    .footer-text {
      flex-direction: column;
      gap: 0.25rem;
      font-size: 0.85rem;
    }
  }
  
  @media (max-width: 480px) {
    .page-header {
      padding: 1rem 0.75rem;
    }
    
    .page-main {
      padding: 1rem 0.75rem;
    }
    
    .email-form-card {
      padding: 1rem;
      border-radius: 12px;
    }
    
    .form-input,
    .form-textarea {
      padding: 0.75rem;
    }
    
    .templates-section {
      padding: 1rem;
    }
    
    .template-btn {
      padding: 0.75rem;
    }
    
    .send-button {
      padding: 0.875rem 1rem;
      gap: 0.5rem;
    }
    
    .input-counter {
      bottom: 0.5rem;
      right: 0.75rem;
      font-size: 0.7rem;
    }
  }
  
  /* Landscape Mobile */
  @media (max-width: 768px) and (orientation: landscape) {
    .page-header {
      padding: 1rem;
    }
    
    .page-title {
      font-size: 2rem;
    }
    
    .form-textarea {
      min-height: 120px;
    }
  }
  
  /* Tablet Styles */
  @media (min-width: 769px) and (max-width: 1024px) {
    .page-main {
      padding: 2rem 1.5rem;
    }
    
    .templates-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  /* Large Desktop */
  @media (min-width: 1200px) {
    .page-main {
      max-width: 900px;
    }
    
    .email-form-card {
      padding: 2.5rem;
    }
  }
  
  /* High DPI Displays */
  @media (min-resolution: 192dpi) {
    .email-form-card {
      border-width: 0.5px;
    }
  }
  
  /* Dark Mode Support */
  @media (prefers-color-scheme: dark) {
    .bulk-email-page {
      background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #0f0f0f 100%);
    }
  }
  
  /* Reduced Motion */
  @media (prefers-reduced-motion: reduce) {
    .send-button,
    .template-btn,
    .message {
      transition: none;
    }
    
    .send-button:hover {
      transform: none;
    }
    
    .template-btn:hover {
      transform: none;
    }
    
    .button-spinner {
      animation: none;
    }
    
    .slideIn {
      animation: none;
    }
  }
  
  /* Print Styles */
  @media print {
    .bulk-email-page {
      background: white;
      color: black;
    }
    
    .send-button,
    .templates-section {
      display: none;
    }
  }
  
  /* Focus Styles for Accessibility */
  .form-input:focus,
  .form-textarea:focus,
  .send-button:focus,
  .template-btn:focus {
    outline: 2px solid #2bb8dd;
    outline-offset: 2px;
  }
  
  /* High Contrast Mode */
  @media (prefers-contrast: high) {
    .email-form-card {
      border-width: 3px;
    }
    
    .form-input,
    .form-textarea {
      border-width: 3px;
    }
  }
  /* Add these styles to your existing CSS file */

.stats-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stats-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-icon {
  font-size: 2rem;
  margin-bottom: 8px;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 0.875rem;
  opacity: 0.9;
}

.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  background-color: white;
  transition: border-color 0.2s ease;
}

.form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.group-description {
  margin-top: 8px;
}

.description-text {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
  padding: 8px 12px;
  background-color: #f9fafb;
  border-radius: 6px;
  border-left: 3px solid #3b82f6;
}

.templates-section {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.templates-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
  text-transform: capitalize;
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.template-btn {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 500;
}

.template-btn:hover:not(:disabled) {
  border-color: #3b82f6;
  background-color: #f0f9ff;
  transform: translateY(-1px);
}

.template-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.template-icon {
  font-size: 1.5rem;
}

.send-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 32px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 56px;
}

.send-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .templates-grid {
    grid-template-columns: 1fr;
  }
  
  .stat-card {
    padding: 16px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
}
/* Header - minimal changes */
.page-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 2rem 0;
  margin-bottom: 2rem;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.title-icon {
  font-size: 2.5rem;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.page-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 400;
}

/* Main Content */
.page-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem 4rem;
}

.email-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Statistics Section */
.stats-section {
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(43, 184, 221, 0.2);
}

.stats-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2bb8dd;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
}

.stat-card {
  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);
  color: white;
  padding: 2rem;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(43, 184, 221, 0.3);
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.stat-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(43, 184, 221, 0.4);
}

.stat-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.95;
  font-weight: 500;
}

/* Messages */
.message {
  padding: 1rem 1.5rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 500;
  position: relative;
  backdrop-filter: blur(10px);
}

.error-message {
  background: linear-gradient(135deg, #1a0f0f 0%, #2a1a1a 100%);
  border: 1px solid #dc2626;
  color: #ff6b6b;
}

.success-message {
  background: linear-gradient(135deg, #0f1a0f 0%, #1a2a1a 100%);
  border: 1px solid #16a34a;
  color: #4ade80;
}

.message-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: currentColor;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  margin-left: auto;
}

.message-close:hover {
  opacity: 1;
}

/* Email Form Card */
.email-form-card {
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(43, 184, 221, 0.2);
}

.card-header {
  text-align: center;
  margin-bottom: 2rem;
}

.card-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2bb8dd;
  margin-bottom: 0.5rem;
}

.card-subtitle {
  font-size: 1rem;
  color: #a0a0a0;
  margin: 0;
}

/* Form Elements */
.form-group {
  margin-bottom: 2rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
}

.label-required {
  color: #ff6b6b;
}

.input-wrapper {
  position: relative;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 1rem 1.25rem;
  border: 2px solid #333;
  border-radius: 12px;
  font-size: 1rem;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  color: #e0e0e0;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #2bb8dd;
  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.2);
  transform: translateY(-1px);
}

.form-textarea {
  resize: vertical;
  min-height: 150px;
  line-height: 1.6;
}

.input-counter {
  position: absolute;
  bottom: 0.75rem;
  right: 1rem;
  font-size: 0.75rem;
  color: #888;
  background: rgba(26, 26, 26, 0.9);
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
}

/* Group Description */
.group-description {
  margin-top: 0.75rem;
}

.description-text {
  font-size: 0.9rem;
  color: #b0b0b0;
  margin: 0;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border-radius: 10px;
  border-left: 4px solid #2bb8dd;
  font-weight: 500;
}

/* Templates Section */
.templates-section {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border-radius: 16px;
  padding: 2rem;
  margin: 2rem 0;
  border: 1px solid rgba(43, 184, 221, 0.1);
}

.templates-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2bb8dd;
  margin-bottom: 1.5rem;
  text-transform: capitalize;
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.template-btn {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%);
  border: 2px solid #333;
  border-radius: 12px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.template-btn:hover:not(:disabled) {
  border-color: #2bb8dd;
  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(43, 184, 221, 0.3);
}

.template-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.template-icon {
  font-size: 2rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

/* Send Button */
.form-actions {
  text-align: center;
  margin-top: 2rem;
}

.send-button {
  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 1.25rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 60px;
  box-shadow: 0 10px 30px rgba(43, 184, 221, 0.3);
  position: relative;
  overflow: hidden;
}

.send-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.send-button:hover:not(:disabled)::before {
  left: 100%;
}

.send-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.4);
}

.send-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.button-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.button-icon {
  font-size: 1.25rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Footer */
.page-footer {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 2rem 0;
  margin-top: 2rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.footer-text {
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.footer-icon {
  font-size: 1.25rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .page-header {
    padding: 1.5rem 0;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .page-main {
    padding: 0 1rem 2rem;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  
  .stat-card {
    padding: 1.5rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
  
  .templates-grid {
    grid-template-columns: 1fr;
  }
  
  .email-form-card {
    padding: 1.5rem;
  }
  
  .card-title {
    font-size: 1.5rem;
  }
  
  .send-button {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .page-title {
    font-size: 1.75rem;
    flex-direction: column;
    gap: 0.5rem;
  }
  .form-input,
  .form-select,
  .form-textarea {
    padding: 0.875rem 1rem;
    font-size: 0.95rem;
  }
  
  .email-form-card {
    padding: 1rem;
  }
  
  .templates-section {
    padding: 1.5rem;
  }
  
  .template-btn {
    padding: 1.25rem;
  }
  
  .send-button {
    width: 100%;
    padding: 1rem 1.5rem;
  }
}

/* Additional animations and effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stats-section,
.email-form-card {
  animation: fadeInUp 0.6s ease-out;
}

.stat-card:nth-child(1) { animation-delay: 0.1s; }
.stat-card:nth-child(2) { animation-delay: 0.2s; }
.stat-card:nth-child(3) { animation-delay: 0.3s; }
.stat-card:nth-child(4) { animation-delay: 0.4s; }

/* Custom scrollbar for textarea */
.form-textarea::-webkit-scrollbar {
  width: 8px;
}

.form-textarea::-webkit-scrollbar-track {
  background: #2a2a2a;
  border-radius: 4px;
}

.form-textarea::-webkit-scrollbar-thumb {
  background: #2bb8dd;
  border-radius: 4px;
}

.form-textarea::-webkit-scrollbar-thumb:hover {
  background: #1e90b8;
}

/* Loading states */
.form-input:disabled,
.form-select:disabled,
.form-textarea:disabled {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  color: #666;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Focus states for better accessibility */
.template-btn:focus,
.send-button:focus {
  outline: 2px solid #2bb8dd;
  outline-offset: 2px;
}

/* Success animation for messages */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.success-message {
  animation: slideInRight 0.3s ease-out;
}

.error-message {
  animation: slideInRight 0.3s ease-out;
}

/* Enhanced button states */
.template-btn:active {
  transform: translateY(1px);
}

.send-button:active:not(:disabled) {
  transform: translateY(-1px);
}

/* Form validation styles */
.form-input:invalid,
.form-select:invalid,
.form-textarea:invalid {
  border-color: #ff6b6b;
}

.form-input:valid,
.form-select:valid,
.form-textarea:valid {
  border-color: #4ade80;
}

/* Placeholder styles */
.form-input::placeholder,
.form-select::placeholder,
.form-textarea::placeholder {
  color: #888;
}

/* Selection styles */
.form-input::selection,
.form-textarea::selection {
  background: rgba(43, 184, 221, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/pages/BulkEmailPage.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,0EAA0E;IAC1E,cAAc;IACd,uFAAuF;IACvF,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,8FAA8F;IAC9F,gDAAgD;IAChD,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,qDAAqD;EACvD;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA,aAAa;EACb;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,6DAA6D;IAC7D,yBAAyB;IACzB,6CAA6C;EAC/C;;EAEA;IACE,6DAA6D;IAC7D,yBAAyB;IACzB,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,oBAAoB;EACpB;IACE,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,qCAAqC;EACvC;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,qBAAqB;IACrB,yCAAyC;IACzC,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;EACd;;EAEA;;IAEE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;IAC7C,8BAA8B;EAChC;;EAEA;;IAEE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA,sBAAsB;EACtB;IACE,eAAe;IACf,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;IACnC,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;IACrB,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA,eAAe;EACf;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,6BAA6B;EAC7B;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;MACrB,oBAAoB;IACtB;;IAEA;MACE,WAAW;IACb;;IAEA;;MAEE,sBAAsB;MACtB,eAAe,EAAE,yBAAyB;IAC5C;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,0BAA0B;MAC1B,YAAY;IACd;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,oBAAoB;MACpB,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;MACb,mBAAmB;IACrB;;IAEA;;MAEE,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,cAAc;MACd,cAAc;MACd,iBAAiB;IACnB;EACF;;EAEA,qBAAqB;EACrB;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA,kBAAkB;EAClB;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,qCAAqC;IACvC;EACF;;EAEA,kBAAkB;EAClB;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,mBAAmB;IACrB;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,0EAA0E;IAC5E;EACF;;EAEA,mBAAmB;EACnB;IACE;;;MAGE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,iBAAiB;EACjB;IACE;MACE,iBAAiB;MACjB,YAAY;IACd;;IAEA;;MAEE,aAAa;IACf;EACF;;EAEA,mCAAmC;EACnC;;;;IAIE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;IACE;MACE,iBAAiB;IACnB;;IAEA;;MAEE,iBAAiB;IACnB;EACF;EACA,+CAA+C;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,iDAAiD;EACjD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;EACb;EACA;;;IAGE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,qBAAqB,EAAE;;AAEjD,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;;EAGE,6DAA6D;EAC7D,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA,0CAA0C;AAC1C;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;;;EAGE,WAAW;AACb;;AAEA,qBAAqB;AACrB;;EAEE,mCAAmC;AACrC","sourcesContent":["/* Base Styles */\n* {\n    box-sizing: border-box;\n  }\n  \n  .bulk-email-page {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);\n    color: #ffffff;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    line-height: 1.6;\n  }\n  \n  /* Header */\n  .page-header {\n    background: linear-gradient(135deg, rgba(43, 184, 221, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%);\n    border-bottom: 1px solid rgba(43, 184, 221, 0.2);\n    padding: 2rem 1rem;\n    text-align: center;\n  }\n  \n  .header-content {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .page-title {\n    font-size: clamp(2rem, 5vw, 3.5rem);\n    font-weight: 800;\n    background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    margin: 0 0 0.5rem 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n  }\n  \n  .title-icon {\n    font-size: 0.8em;\n    filter: drop-shadow(0 0 10px rgba(43, 184, 221, 0.5));\n  }\n  \n  .page-subtitle {\n    font-size: clamp(1rem, 3vw, 1.25rem);\n    color: #94a3b8;\n    margin: 0;\n    font-weight: 400;\n  }\n  \n  /* Main Content */\n  .page-main {\n    padding: 2rem 1rem;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  \n  .email-container {\n    width: 100%;\n  }\n  \n  /* Messages */\n  .message {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1rem 1.5rem;\n    border-radius: 12px;\n    margin-bottom: 2rem;\n    font-weight: 500;\n    position: relative;\n    animation: slideIn 0.3s ease-out;\n  }\n  \n  .error-message {\n    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n    border: 1px solid #ef4444;\n    box-shadow: 0 4px 15px rgba(220, 38, 38, 0.2);\n  }\n  \n  .success-message {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    border: 1px solid #22c55e;\n    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.2);\n  }\n  \n  .message-icon {\n    font-size: 1.25rem;\n    flex-shrink: 0;\n  }\n  \n  .message-text {\n    flex: 1;\n  }\n  \n  .message-close {\n    background: none;\n    border: none;\n    color: currentColor;\n    font-size: 1.5rem;\n    cursor: pointer;\n    padding: 0;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background-color 0.2s ease;\n  }\n  \n  .message-close:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n  \n  /* Email Form Card */\n  .email-form-card {\n    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n    border: 1px solid #475569;\n    border-radius: 20px;\n    padding: 2rem;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(10px);\n  }\n  \n  .card-header {\n    text-align: center;\n    margin-bottom: 2rem;\n    padding-bottom: 1.5rem;\n    border-bottom: 1px solid #475569;\n  }\n  \n  .card-title {\n    font-size: clamp(1.5rem, 4vw, 2rem);\n    font-weight: 700;\n    color: #2bb8dd !important;\n    margin: 0 0 0.5rem 0;\n  }\n  \n  .card-subtitle {\n    color: #94a3b8;\n    margin: 0;\n    font-size: clamp(0.9rem, 2.5vw, 1rem);\n  }\n  \n  /* Form Styles */\n  .email-form {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n  }\n  \n  .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .form-label {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    font-weight: 600;\n    font-size: 1.1rem;\n    color: #e2e8f0;\n  }\n  \n  .label-text {\n    color: #e2e8f0;\n  }\n  \n  .label-required {\n    color: #ef4444;\n    font-weight: 700;\n  }\n  \n  .input-wrapper {\n    position: relative;\n  }\n  \n  .form-input,\n  .form-textarea {\n    width: 100%;\n    padding: 1rem 1.25rem;\n    background: rgba(0, 0, 0, 0.4) !important;\n    border: 2px solid #475569;\n    border-radius: 12px;\n    color: #ffffff;\n    font-size: 1rem;\n    font-family: inherit;\n    transition: all 0.3s ease;\n    resize: none;\n  }\n  \n  .form-input:focus,\n  .form-textarea:focus {\n    outline: none;\n    border-color: #2bb8dd;\n    box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.1);\n    background: rgba(0, 0, 0, 0.6);\n  }\n  \n  .form-input:disabled,\n  .form-textarea:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  \n  .form-textarea {\n    min-height: 200px;\n    line-height: 1.6;\n    font-family: inherit;\n  }\n  \n  .input-counter {\n    position: absolute;\n    bottom: 0.75rem;\n    right: 1rem;\n    font-size: 0.75rem;\n    color: #64748b;\n    background: rgba(0, 0, 0, 0.7);\n    padding: 0.25rem 0.5rem;\n    border-radius: 6px;\n    pointer-events: none;\n  }\n  \n  /* Templates Section */\n  .templates-section {\n    padding: 1.5rem;\n    background: rgba(43, 184, 221, 0.05);\n    border: 1px solid rgba(43, 184, 221, 0.2);\n    border-radius: 15px;\n    margin: 1rem 0;\n  }\n  \n  .templates-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #2bb8dd;\n    margin: 0 0 1rem 0;\n    text-align: center;\n  }\n  \n  .templates-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1rem;\n  }\n  \n  .template-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 1rem;\n    background: rgba(43, 184, 221, 0.1);\n    border: 1px solid rgba(43, 184, 221, 0.3);\n    border-radius: 12px;\n    color: #2bb8dd;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n  \n  .template-btn:hover:not(:disabled) {\n    background: rgba(43, 184, 221, 0.2);\n    border-color: #2bb8dd;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(43, 184, 221, 0.2);\n  }\n  \n  .template-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n  }\n  \n  .template-icon {\n    font-size: 1.5rem;\n  }\n  \n  /* Form Actions */\n  .form-actions {\n    margin-top: 1rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #475569;\n  }\n  \n  .send-button {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    padding: 1.25rem 2rem;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    border: none;\n    border-radius: 15px;\n    color: #ffffff;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .send-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(16, 185, 129, 0.3);\n  }\n  \n  .send-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n  \n  .button-spinner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid transparent;\n    border-top: 2px solid currentColor;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  .button-icon {\n    font-size: 1.2rem;\n  }\n  \n  .button-text {\n    font-weight: 700;\n  }\n  \n  /* Footer */\n  .page-footer {\n    background: rgba(0, 0, 0, 0.2);\n    border-top: 1px solid #475569;\n    padding: 1.5rem 1rem;\n    margin-top: 2rem;\n  }\n  \n  .footer-content {\n    max-width: 800px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .footer-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    color: #94a3b8;\n    margin: 0;\n    font-size: 0.9rem;\n  }\n  \n  .footer-icon {\n    font-size: 1rem;\n    color: #f59e0b;\n  }\n  \n  /* Animations */\n  @keyframes slideIn {\n    from {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  /* Mobile Responsive Design */\n  @media (max-width: 768px) {\n    .page-header {\n      padding: 1.5rem 1rem;\n    }\n    \n    .page-title {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n    \n    .title-icon {\n      font-size: 1em;\n    }\n    \n    .page-main {\n      padding: 1.5rem 1rem;\n    }\n    \n    .email-form-card {\n      padding: 1.5rem;\n      border-radius: 15px;\n    }\n    \n    .card-header {\n      margin-bottom: 1.5rem;\n      padding-bottom: 1rem;\n    }\n    \n    .email-form {\n      gap: 1.5rem;\n    }\n    \n    .form-input,\n    .form-textarea {\n      padding: 0.875rem 1rem;\n      font-size: 16px; /* Prevents zoom on iOS */\n    }\n    \n    .form-textarea {\n      min-height: 150px;\n    }\n    \n    .templates-grid {\n      grid-template-columns: 1fr;\n      gap: 0.75rem;\n    }\n    \n    .template-btn {\n      padding: 0.875rem;\n      font-size: 0.85rem;\n    }\n    \n    .template-icon {\n      font-size: 1.25rem;\n    }\n    \n    .send-button {\n      padding: 1rem 1.5rem;\n      font-size: 1rem;\n    }\n    \n    .message {\n      padding: 0.875rem 1rem;\n      gap: 0.75rem;\n    }\n    \n    .message-icon {\n      font-size: 1.1rem;\n    }\n    \n    .footer-text {\n      flex-direction: column;\n      gap: 0.25rem;\n      font-size: 0.85rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .page-header {\n      padding: 1rem 0.75rem;\n    }\n    \n    .page-main {\n      padding: 1rem 0.75rem;\n    }\n    \n    .email-form-card {\n      padding: 1rem;\n      border-radius: 12px;\n    }\n    \n    .form-input,\n    .form-textarea {\n      padding: 0.75rem;\n    }\n    \n    .templates-section {\n      padding: 1rem;\n    }\n    \n    .template-btn {\n      padding: 0.75rem;\n    }\n    \n    .send-button {\n      padding: 0.875rem 1rem;\n      gap: 0.5rem;\n    }\n    \n    .input-counter {\n      bottom: 0.5rem;\n      right: 0.75rem;\n      font-size: 0.7rem;\n    }\n  }\n  \n  /* Landscape Mobile */\n  @media (max-width: 768px) and (orientation: landscape) {\n    .page-header {\n      padding: 1rem;\n    }\n    \n    .page-title {\n      font-size: 2rem;\n    }\n    \n    .form-textarea {\n      min-height: 120px;\n    }\n  }\n  \n  /* Tablet Styles */\n  @media (min-width: 769px) and (max-width: 1024px) {\n    .page-main {\n      padding: 2rem 1.5rem;\n    }\n    \n    .templates-grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  \n  /* Large Desktop */\n  @media (min-width: 1200px) {\n    .page-main {\n      max-width: 900px;\n    }\n    \n    .email-form-card {\n      padding: 2.5rem;\n    }\n  }\n  \n  /* High DPI Displays */\n  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n    .email-form-card {\n      border-width: 0.5px;\n    }\n  }\n  \n  /* Dark Mode Support */\n  @media (prefers-color-scheme: dark) {\n    .bulk-email-page {\n      background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #0f0f0f 100%);\n    }\n  }\n  \n  /* Reduced Motion */\n  @media (prefers-reduced-motion: reduce) {\n    .send-button,\n    .template-btn,\n    .message {\n      transition: none;\n    }\n    \n    .send-button:hover {\n      transform: none;\n    }\n    \n    .template-btn:hover {\n      transform: none;\n    }\n    \n    .button-spinner {\n      animation: none;\n    }\n    \n    .slideIn {\n      animation: none;\n    }\n  }\n  \n  /* Print Styles */\n  @media print {\n    .bulk-email-page {\n      background: white;\n      color: black;\n    }\n    \n    .send-button,\n    .templates-section {\n      display: none;\n    }\n  }\n  \n  /* Focus Styles for Accessibility */\n  .form-input:focus,\n  .form-textarea:focus,\n  .send-button:focus,\n  .template-btn:focus {\n    outline: 2px solid #2bb8dd;\n    outline-offset: 2px;\n  }\n  \n  /* High Contrast Mode */\n  @media (prefers-contrast: high) {\n    .email-form-card {\n      border-width: 3px;\n    }\n    \n    .form-input,\n    .form-textarea {\n      border-width: 3px;\n    }\n  }\n  /* Add these styles to your existing CSS file */\n\n.stats-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.stats-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.stat-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition: transform 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  margin-bottom: 8px;\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  opacity: 0.9;\n}\n\n.form-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  background-color: white;\n  transition: border-color 0.2s ease;\n}\n\n.form-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.group-description {\n  margin-top: 8px;\n}\n\n.description-text {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin: 0;\n  padding: 8px 12px;\n  background-color: #f9fafb;\n  border-radius: 6px;\n  border-left: 3px solid #3b82f6;\n}\n\n.templates-section {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px 0;\n}\n\n.templates-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 16px;\n  text-transform: capitalize;\n}\n\n.templates-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n.template-btn {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.template-btn:hover:not(:disabled) {\n  border-color: #3b82f6;\n  background-color: #f0f9ff;\n  transform: translateY(-1px);\n}\n\n.template-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.template-icon {\n  font-size: 1.5rem;\n}\n\n.send-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 16px 32px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 56px;\n}\n\n.send-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.send-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .templates-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .stat-card {\n    padding: 16px;\n  }\n  \n  .stat-number {\n    font-size: 1.5rem;\n  }\n}\n/* Header - minimal changes */\n.page-header {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 2rem 0;\n  margin-bottom: 2rem;\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  text-align: center;\n}\n\n.page-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.title-icon {\n  font-size: 2.5rem;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\n}\n\n.page-subtitle {\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Main Content */\n.page-main {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem 4rem;\n}\n\n.email-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Statistics Section */\n.stats-section {\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(43, 184, 221, 0.2);\n}\n\n.stats-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2bb8dd;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.stat-card {\n  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);\n  color: white;\n  padding: 2rem;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 10px 30px rgba(43, 184, 221, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.stat-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(43, 184, 221, 0.4);\n}\n\n.stat-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.stat-number {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  opacity: 0.95;\n  font-weight: 500;\n}\n\n/* Messages */\n.message {\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 500;\n  position: relative;\n  backdrop-filter: blur(10px);\n}\n\n.error-message {\n  background: linear-gradient(135deg, #1a0f0f 0%, #2a1a1a 100%);\n  border: 1px solid #dc2626;\n  color: #ff6b6b;\n}\n\n.success-message {\n  background: linear-gradient(135deg, #0f1a0f 0%, #1a2a1a 100%);\n  border: 1px solid #16a34a;\n  color: #4ade80;\n}\n\n.message-close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: currentColor;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  margin-left: auto;\n}\n\n.message-close:hover {\n  opacity: 1;\n}\n\n/* Email Form Card */\n.email-form-card {\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  padding: 2.5rem;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(43, 184, 221, 0.2);\n}\n\n.card-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.card-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2bb8dd;\n  margin-bottom: 0.5rem;\n}\n\n.card-subtitle {\n  font-size: 1rem;\n  color: #a0a0a0;\n  margin: 0;\n}\n\n/* Form Elements */\n.form-group {\n  margin-bottom: 2rem;\n}\n\n.form-label {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-weight: 600;\n  color: #e0e0e0;\n  margin-bottom: 0.75rem;\n  font-size: 0.95rem;\n}\n\n.label-required {\n  color: #ff6b6b;\n}\n\n.input-wrapper {\n  position: relative;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  border: 2px solid #333;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  color: #e0e0e0;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: #2bb8dd;\n  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.2);\n  transform: translateY(-1px);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 150px;\n  line-height: 1.6;\n}\n\n.input-counter {\n  position: absolute;\n  bottom: 0.75rem;\n  right: 1rem;\n  font-size: 0.75rem;\n  color: #888;\n  background: rgba(26, 26, 26, 0.9);\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n}\n\n/* Group Description */\n.group-description {\n  margin-top: 0.75rem;\n}\n\n.description-text {\n  font-size: 0.9rem;\n  color: #b0b0b0;\n  margin: 0;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  border-radius: 10px;\n  border-left: 4px solid #2bb8dd;\n  font-weight: 500;\n}\n\n/* Templates Section */\n.templates-section {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  border-radius: 16px;\n  padding: 2rem;\n  margin: 2rem 0;\n  border: 1px solid rgba(43, 184, 221, 0.1);\n}\n\n.templates-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #2bb8dd;\n  margin-bottom: 1.5rem;\n  text-transform: capitalize;\n}\n\n.templates-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.template-btn {\n  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%);\n  border: 2px solid #333;\n  border-radius: 12px;\n  padding: 1.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #e0e0e0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.template-btn:hover:not(:disabled) {\n  border-color: #2bb8dd;\n  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(43, 184, 221, 0.3);\n}\n\n.template-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.template-icon {\n  font-size: 2rem;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n/* Send Button */\n.form-actions {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.send-button {\n  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 1.25rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-height: 60px;\n  box-shadow: 0 10px 30px rgba(43, 184, 221, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.send-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.send-button:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.send-button:hover:not(:disabled) {\n  transform: translateY(-3px);\n  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.4);\n}\n\n.send-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.button-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.button-icon {\n  font-size: 1.25rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Footer */\n.page-footer {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 2rem 0;\n  margin-top: 2rem;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  text-align: center;\n}\n\n.footer-text {\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n  font-size: 0.95rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.footer-icon {\n  font-size: 1.25rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .page-header {\n    padding: 1.5rem 0;\n  }\n  \n  .page-title {\n    font-size: 2rem;\n  }\n  \n  .page-main {\n    padding: 0 1rem 2rem;\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n  \n  .stat-card {\n    padding: 1.5rem;\n  }\n  \n  .stat-number {\n    font-size: 2rem;\n  }\n  \n  .templates-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .email-form-card {\n    padding: 1.5rem;\n  }\n  \n  .card-title {\n    font-size: 1.5rem;\n  }\n  \n  .send-button {\n    padding: 1rem 2rem;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .page-title {\n    font-size: 1.75rem;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  .form-input,\n  .form-select,\n  .form-textarea {\n    padding: 0.875rem 1rem;\n    font-size: 0.95rem;\n  }\n  \n  .email-form-card {\n    padding: 1rem;\n  }\n  \n  .templates-section {\n    padding: 1.5rem;\n  }\n  \n  .template-btn {\n    padding: 1.25rem;\n  }\n  \n  .send-button {\n    width: 100%;\n    padding: 1rem 1.5rem;\n  }\n}\n\n/* Additional animations and effects */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.stats-section,\n.email-form-card {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.stat-card:nth-child(1) { animation-delay: 0.1s; }\n.stat-card:nth-child(2) { animation-delay: 0.2s; }\n.stat-card:nth-child(3) { animation-delay: 0.3s; }\n.stat-card:nth-child(4) { animation-delay: 0.4s; }\n\n/* Custom scrollbar for textarea */\n.form-textarea::-webkit-scrollbar {\n  width: 8px;\n}\n\n.form-textarea::-webkit-scrollbar-track {\n  background: #2a2a2a;\n  border-radius: 4px;\n}\n\n.form-textarea::-webkit-scrollbar-thumb {\n  background: #2bb8dd;\n  border-radius: 4px;\n}\n\n.form-textarea::-webkit-scrollbar-thumb:hover {\n  background: #1e90b8;\n}\n\n/* Loading states */\n.form-input:disabled,\n.form-select:disabled,\n.form-textarea:disabled {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  color: #666;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Focus states for better accessibility */\n.template-btn:focus,\n.send-button:focus {\n  outline: 2px solid #2bb8dd;\n  outline-offset: 2px;\n}\n\n/* Success animation for messages */\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.success-message {\n  animation: slideInRight 0.3s ease-out;\n}\n\n.error-message {\n  animation: slideInRight 0.3s ease-out;\n}\n\n/* Enhanced button states */\n.template-btn:active {\n  transform: translateY(1px);\n}\n\n.send-button:active:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n/* Form validation styles */\n.form-input:invalid,\n.form-select:invalid,\n.form-textarea:invalid {\n  border-color: #ff6b6b;\n}\n\n.form-input:valid,\n.form-select:valid,\n.form-textarea:valid {\n  border-color: #4ade80;\n}\n\n/* Placeholder styles */\n.form-input::placeholder,\n.form-select::placeholder,\n.form-textarea::placeholder {\n  color: #888;\n}\n\n/* Selection styles */\n.form-input::selection,\n.form-textarea::selection {\n  background: rgba(43, 184, 221, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
